import { useCurrentProject } from 'api/ProjectsAPI';

export const useCustomSettings = () => {
  const {
    data,
    refetch: refectCurrentProjectSettings,
    isLoading: isLoadingCurrentProjectSettings,
  } = useCurrentProject();

  const { customMTAESPLabel, logoUrl } = data || {};

  return {
    customMTAESPLabel,
    isLoadingCurrentProjectSettings,
    logoUrl,
    refectCurrentProjectSettings,
  };
};
